import { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Bulb from "../../assets/images/bulb.png";
import SelectBG from "../../assets/images/selectBack.svg";
import PerformanceCharts from "./PerformaceCharts";
import KpiCards from "./KpiCards";
import WinsCharts from "./WinsChart";
import FyChart from "./FyChart";
import CPI from "./Sec3BarGraph/CPI";
import DI from "./Sec3BarGraph/DI";
import IPI from "./Sec3BarGraph/IPI";
import GDP from "./Sec3BarGraph/GDP";
import MobileView from "./Sec3BarGraph/MobileView";
import ComponentLoader from "../../components/loader/ComponentLoader";

export default function HomeTab() {
  const [kpiValues, setKpiValues] = useState<any>({});
  const [key, setKey] = useState("Performance");
  const [countries, setCountries] = useState<any>([]);
  const [dataMobileView, setDataMobileView] = useState<any>({});
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 768);
  const [percentageDataCPI, setPercentageDataCPI] = useState<any>([]);
  const [percentageDataIPI, setPercentageDataIPI] = useState<any>([]);
  const [percentageDataDI, setPercentageDataDI] = useState<any>([]);
  const [percentageDataGDP, setPercentageDataGDP] = useState<any>([]);
  const [fYChartData, setFYChartData] = useState<any>([]);
  const [boxfYChartData, setBoxfYChartData] = useState<any>([]);
  const [countryPercentArray, setCountryPercentArray] = useState<any>([]);
  const [totalABI, setTotalABI] = useState<any>([]);
  const [formattedData, setFormattedData] = useState<any[]>([]);
  const [BoxformattedData, setBoxFormattedData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // debugger
    document.getElementById("componentLoader")?.classList.add("h-50vh");
    if (loading) {
      document.getElementById("graph_div")?.classList.add("blur");
    } else {
      document.getElementById("graph_div")?.classList.remove("blur");
    }
  }, [loading]);

  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };

  useEffect(() => {
    // Add event listener for resize events
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const fetchExcelData = async () => {
    try {
      const access_token = localStorage.getItem("accesstoken") || "";
      // const role_token = localStorage.getItem("roleToken") || "";

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api/Pulse/fetch-excel`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
            // "X-Role-Key": role_token,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!Array.isArray(data)) {
        throw new Error("Invalid response structure: expected an array");
      }

      const normalizedData = data.map((row) => {
        if ("AC/LEQ1" in row) {
          return {
            ...row,
            ACLEGACQ424: row["AC/LEQ1"],
            // Remove the old key if desired
            // ...(row['AC/LEQ1'] && { ACLEGACQ424: row['AC/LEQ1'] }),
          };
        }
        return row;
      });
      // Define the condition for filtering
      const condition = {
        Country: "Total ABI",
        LEVersion: "LE 3+9 2025",
      };

      const accounts = ["Volume", "Net Revenue", "MACO"];
      const kpiValues: Record<string, any> = {};

      // Calculate KPI values for each account
      accounts.forEach((account) => {
        const matchingRow = normalizedData.find(
          (row) =>
            row.Country === condition.Country &&
            row.LEVersion === condition.LEVersion &&
            row.Account === account
        );

        if (matchingRow) {
          const ACLEGACQ224 = parseFloat(matchingRow.ACLEGACQ424) / 1000;
          const lyAmended = parseFloat(matchingRow.LYAMQ1) / 1000;
          const buAmended = parseFloat(matchingRow.BUAMQ1) / 1000;

          if (!isNaN(ACLEGACQ224) && !isNaN(lyAmended) && !isNaN(buAmended)) {
            const lyComparison = (ACLEGACQ224 / lyAmended - 1) * 100;
            const buComparison = (ACLEGACQ224 / buAmended - 1) * 100;

            kpiValues[account] = {
              ACLEGACQ224: ACLEGACQ224.toFixed(2),
              lyComparison: lyComparison.toFixed(1),
              buComparison: buComparison.toFixed(1),
            };
          }
        }
      });

      return kpiValues;
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Re-throw to handle in the component
    }
  };

  const fetchEconomicIndicatorData = async () => {
    try {
      const access_token = localStorage.getItem("accesstoken") || "";
      // const role_token = localStorage.getItem("roleToken") || "";

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api/Pulse/economic_indicators`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
            // "X-Role-Key": role_token,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      // Create percentageData array with country and CPI value
      const percentageData = ["CPI", "IPI", "DI", "GDP"].reduce((acc, key) => {
        acc[key] = Object.entries(data.data).map(([country, indicators]) => ({
          country,
          value: (indicators as Record<string, number>)[key],
        }));
        return acc;
      }, {} as Record<string, { country: string; value: number }[]>);

      setPercentageDataCPI(percentageData["CPI"]);
      setPercentageDataIPI(percentageData["IPI"]);
      setPercentageDataDI(percentageData["DI"]);
      setPercentageDataGDP(percentageData["GDP"]);
      setCountries(percentageData["CPI"]);
      updateData({
        CPI: percentageData["CPI"],
        DI: percentageData["DI"],
        IPI: percentageData["IPI"],
        GDP: percentageData["GDP"],
      });
      return true; // Indicate success
    } catch (error) {
      console.error("Error reading the Excel file:", error);
    }
  };

  const fetchFYchartData = async () => {
    try {
      const access_token = localStorage.getItem("accesstoken") || "";
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api/Pulse/calculate_Fychart`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
            // "X-Role-Key": role_token,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const boxData = data.results[1];
      const waterfallData = data.results[0];

      setFYChartData(waterfallData);
      setBoxfYChartData(boxData);
      return true; // Indicate success
    } catch (error) {
      console.error("Error reading the Excel file:", error);
    }
  };

  const fetchPerformanceData = async () => {
    try {
      const access_token = localStorage.getItem("accesstoken") || "";
      // const role_token = localStorage.getItem("roleToken") || "";

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api/Pulse/calculate_performance`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
            // "X-Role-Key": role_token,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      const { results } = data;

      if (!Array.isArray(results)) {
        throw new Error("Invalid response structure: results is not an array");
      }
      setCountryPercentArray(results);
      setTotalABI(
        results.find((entry) => entry.Country === "Total ABI")?.value ?? 0
      );
      return true; // Indicate success
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Re-throw to handle in the component
    }
  };

  const fetchWinsChartData = async () => {
    try {
      const access_token = localStorage.getItem("accesstoken") || "";
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api/Pulse/calculate_wins`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
            // "X-Role-Key": role_token,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      const boxData = data.results[0];
      const waterfallData = data.results[1];
      setBoxFormattedData(boxData);
      setFormattedData(waterfallData);
      return true; // Indicate success
    } catch (error) {
      console.error("Error reading the Excel file:", error);
    }
  };

  // Inside your component
  useEffect(() => {
    let isMounted = true; // Flag to prevent state updates after unmount

    const loadData = async () => {
      try {
        setLoading(true);
        try {
          const [
            kpiValues,
            economicData,
            fyChartData,
            performanceData,
            winsChartData,
          ] = await Promise.all([
            fetchExcelData(),
            fetchEconomicIndicatorData(),
            fetchFYchartData(),
            fetchPerformanceData(),
            fetchWinsChartData(),
          ]);

          if (isMounted) {
            setKpiValues(kpiValues);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          if (isMounted) {
            setLoading(false);
          }
        }
      } catch (error) {
        console.error("Error in component:", error);
        // Handle unauthorized access if needed
        if (error instanceof Error && error.message.includes("401")) {
          // logout();
        }
      }
    };

    loadData();

    return () => {
      isMounted = false; // Cleanup function
    };
  }, []);

  async function updateData(e: any) {
    setDataMobileView((prevState: any) => ({
      ...prevState,
      ...e,
    }));
  }

  return (
    <>
      {loading ? <ComponentLoader /> : null}
      <div id="graph_div">
        <KpiCards kpiValues={kpiValues} />

        {/* <div className="TabFilters">
        <select name="" id="">
          <option value="Quarter">vs LY</option>
          <option value="Quarter">vs LY</option>
          <option value="Quarter">vs LY</option>
          <option value="Quarter">vs LY</option>
        </select>
        <select name="" id="">
          <option value="Quarter">Quarter 1</option>
          <option value="Quarter">Quarter 2</option>
          <option value="Quarter">Quarter 3</option>
          <option value="Quarter">Quarter 4</option>
        </select>
      </div> */}
        <div className="MobileTabDropdown">
          <label>Please Select the Graph.</label>
          <div className="selectWrap">
            <img src={SelectBG} />
            <select
              name=""
              id=""
              value={key}
              onChange={(k) => setKey(k.target.value || "Performance")}
            >
              <option value="Performance">Performance</option>
              <option value="WinsMisses">Wins & Misses</option>
              <option value="Trends">Trends</option>
              <option value="FY_Projection">FY Projection</option>
            </select>
          </div>
        </div>
        <Tabs
          defaultActiveKey="Performance"
          id="home-tabs"
          activeKey={key}
          onSelect={(k) => setKey(k || "Performance")}
        >
          <Tab eventKey="Performance" title="Performance">
            <div className="tabContent">
              <div className="row">
                <div className="col-12 mt-4">
                  <div className="chartBG">
                    <PerformanceCharts
                      totalABI={totalABI}
                      countryPercentArray={countryPercentArray}
                    />
                  </div>
                </div>
              </div>
              <div className="row mt-5">
                <div className="col-md-12">
                  <div className="SmallTitle">
                    <div>
                      <img src={Bulb} />
                    </div>
                    <div>
                      <h2>Insights</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-4 mb-5">
                <div className="col-md-4">
                  <div className="greyCard insightCard">
                    <p className="m-0">
                      <span className="yellow f-20">US Beer </span>
                    </p>
                    <p>
                      Trade uncertainties coupled with risk of new tariff
                      policies, add to the recessionary pressure and declining
                      consumer confidence leading to a sharp decline in volumes.
                      Industry decline higher at -6.2% in Q1.
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="greyCard insightCard">
                    <p className="m-0">
                      <span className="yellow f-20">EUR </span>
                    </p>
                    <p>
                      Belgium and Germany attributing to the decline majorly
                      induced by slowing economic growth. Additional dip
                      contributed by national strikes in Netherlands. Besides
                      the overall decline, UK growth opportunity from San
                      Miguel acquisition.
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="greyCard insightCard">
                    <p className="m-0">
                      <span className="yellow f-20">China</span>
                    </p>
                    <p>
                      Continuation of decline in beer industry, contributed by
                      sharp drop in consumer confidence and housing sales. Brand
                      mix under pressure, with sales drop in Premium Segment.
                      Additional impact from the recent imposition of US tariffs
                      is expected to reflect in upcoming months. 
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Tab>
          <Tab eventKey="WinsMisses" title="Wins & Misses">
            <div className="tabContent">
              <div className="row">
                <div className="col-12 mt-4">
                  <div className="chartBG">
                    <WinsCharts
                      formattedData={formattedData}
                      BoxformattedData={BoxformattedData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Tab>
          <Tab eventKey="Trends" title="Trends">
            <div className="tabContent">
              <div className="row">
                <div className="col-12 mt-4">
                  <div className="chartBG">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="chartTitleData">
                          <h2 className="ChartTitle ChartTitle-sec3">
                            Macro indicator trends projected for 2025 FY
                          </h2>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div
                          className="volumeChart desktopView"
                          style={{ display: isMobile ? "none" : "block" }}
                        >
                          <div className="subVolumeChart">
                            <div
                              className="outer-background"
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                background: "#161616",
                                borderRadius: "13.092px",
                                padding: "20px",
                                gap: "10px",
                              }}
                            >
                              <div
                                className="label-names"
                                style={{ width: "10%" }}
                              >
                                <div
                                  className="country-list"
                                  style={{
                                    paddingTop: "79px",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "27px",
                                    color: "#fff",
                                    fontSize: "15px",
                                  }}
                                >
                                  {countries.length ? (
                                    [...countries]
                                      .reverse()
                                      .map((country: any) => (
                                        <div className="country-item">
                                          {country.country}
                                        </div>
                                      ))
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                              <div
                                className="chart-container"
                                style={{
                                  display: "flex",
                                  width: "90%",
                                  gap: "10px",
                                }}
                              >
                                <div
                                  className="inner-background"
                                  style={{
                                    width: "50%",
                                    background: "#202020",
                                    boxShadow:
                                      " 7.855px 5.237px 18.917px 0px rgba(0, 0, 0, 0.25)",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                    borderRadius: "10px",
                                    padding: "10px",
                                  }}
                                >
                                  <div style={{ display: "flex", gap: "5px" }}>
                                    <div
                                      className="div-block"
                                      style={{ width: "62%" }}
                                    >
                                      <p className="ta-c">
                                        Consumer Price Index
                                      </p>
                                      <CPI value={percentageDataCPI} />
                                    </div>
                                    <div
                                      className="div-block"
                                      style={{ width: "62%" }}
                                    >
                                      <p className="ta-c">Disposable Income</p>
                                      <DI value={percentageDataDI} />
                                    </div>
                                  </div>
                                  <div className="text-block-2">
                                    <p>Demand side indicators</p>
                                  </div>
                                </div>
                                <div
                                  className="inner-background"
                                  style={{
                                    width: "50%",
                                    background: "#202020",
                                    boxShadow:
                                      " 7.855px 5.237px 18.917px 0px rgba(0, 0, 0, 0.25)",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                    borderRadius: "10px",
                                    padding: "10px",
                                  }}
                                >
                                  <div style={{ display: "flex", gap: "5px" }}>
                                    <div
                                      className="div-block"
                                      style={{ width: "62%" }}
                                    >
                                      <p className="ta-c">
                                        Industrial Production Index
                                      </p>
                                      <IPI value={percentageDataIPI}></IPI>
                                    </div>
                                    <div
                                      className="div-block"
                                      style={{ width: "62%" }}
                                    >
                                      <p className="ta-c">GDP</p>
                                      <GDP value={percentageDataGDP}></GDP>
                                    </div>
                                  </div>
                                  <div className="text-block-2">
                                    <p>Supply side indicators</p>
                                  </div>
                                </div>

                                {/* <div
                            className="inner-background beerIndus"
                            style={{
                              width: "24%",
                              background: "transparent",
                              boxShadow:
                                " 7.855px 5.237px 18.917px 0px rgba(0, 0, 0, 0.25)",
                              // height: "46%",
                              display: "flex",
                              flexDirection: "row",
                              gap: "10px",
                              borderRadius: "10px",
                              padding: "10px",
                            }}
                          >
                            <div
                              className="div-block"
                              style={{ width: "100%" }}
                            >
                              <p>Beer Industry YTD</p>
                              <BeerYTD></BeerYTD>
                            </div>
                          </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: isMobile ? "block" : "block" }}>
                          {dataMobileView.CPI &&
                          dataMobileView.CPI.length > 0 &&
                          dataMobileView.DI &&
                          dataMobileView.DI.length > 0 &&
                          dataMobileView.IPI &&
                          dataMobileView.IPI.length > 0 &&
                          dataMobileView.GDP &&
                          dataMobileView.GDP.length > 0 ? (
                            <MobileView inputData={dataMobileView}></MobileView>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="source-text">Source: IHS Markit</div>
              {/* <div className="row mt-5">
              <div className="col-md-12">
                <div className="SmallTitle">
                  <div>
                    <img src={Bulb} />
                  </div>
                  <div>
                    <h2>Insights</h2>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Etiam vel
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4 mb-5">
              <div className="col-md-4">
                <div className="greyCard insightCard">
                  <i className="fa-solid fa-arrow-right"></i>
                  <p className="m-0">
                    <b>US Beer</b>
                  </p>
                  <p>
                    <span className="yellow">Lower PINC</span> expected in YTG
                    (BU inputs) leading to higher YTG volumes in LE (8+4)
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="greyCard insightCard">
                  <i className="fa-solid fa-arrow-right"></i>
                  <p className="m-0">
                    <b>China</b>
                  </p>
                  <p>
                    Higher impact of night life ban observed across regions.{" "}
                    <span className="yellow">
                      Flood impact in Fujian led to lower volumes
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="greyCard insightCard">
                  <i className="fa-solid fa-arrow-right"></i>
                  <p className="m-0">
                    <b>Argentina Beer</b>
                  </p>
                  <p>
                    Declining economic conditions in China impacting Korean
                    exports.{" "}
                    <span className="yellow">
                      Korean Airlines launched its own craft Lager in July
                      leading to higher competition.
                    </span>
                  </p>
                </div>
              </div>
            </div> */}
            </div>
          </Tab>
          <Tab eventKey="FY_Projection" title="FY Projection">
            <div className="tabContent">
              <div className="row">
                <div className="col-12 mt-4">
                  <div className="chartBG">
                    <FyChart
                      formattedData={fYChartData}
                      BoxformattedData={boxfYChartData}
                    />
                    {/*   <WinsCharts
                      formattedData={formattedData}
                      BoxformattedData={BoxformattedData}
                    /> */}
                  </div>
                </div>
              </div>

              {/* <div className="row mt-4 mb-5">
              <div className="col-md-4">
                <div className="greyCard insightCard">
                  <p className="m-0">
                    <b>Lorem Ipsum</b>
                  </p>
                  <p>
                    <span className="yellow">Lorem Ipsum</span> Lorem Ipsum
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="greyCard insightCard">

                  <p className="m-0">
                    <b> Lorem Ipsum</b>
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elitLorem
                    ipsum dolor sit amet, consectetur adipiscing elit
                    <span className="yellow">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="greyCard insightCard">

                  <p className="m-0">
                    <b> Lorem Ipsum</b>
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit{" "}
                    <span className="yellow">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit
                    </span>
                  </p>
                </div>
              </div>
            </div> */}
            </div>
          </Tab>
        </Tabs>
      </div>
    </>
  );
}
